import React from "react";
import { TableContainer, Paper, TableHead, TableBody, TableCell } from "@mui/material";
import {
  GridItem,
  DataCard,
  DataCardHeader,
  DataCardTitle,
  ReportTable,
  ReportTableRow,
  AmountCell
} from "./MonthlyReport.styles";
import { Business } from "@mui/icons-material";
import { formatNumber, isPositiveAmount } from "./MonthlyReport.utils";

const MonthlyReportMerchantsTable = ({ merchants, title = "Merchants" }) => {
  if (!merchants || merchants.length === 0) return null;

  return (
    <GridItem xs={12}>
      <DataCard>
        <DataCardHeader>
          <Business color="primary" />
          <DataCardTitle>{title}</DataCardTitle>
        </DataCardHeader>
        <TableContainer component={Paper}>
          <ReportTable>
            <TableHead>
              <ReportTableRow>
                <TableCell>Merchant Name</TableCell>
                <TableCell>Merchant ID</TableCell>
                <TableCell align="right">Terminals</TableCell>
                <TableCell align="right">Transactions</TableCell>
                <TableCell align="right">Amount</TableCell>
                <TableCell align="right">MDR Revenue</TableCell>
                <TableCell align="right">MID Fee</TableCell>
                <TableCell align="right">Proc. Fee</TableCell>
                <TableCell align="right">Net Residual</TableCell>
              </ReportTableRow>
            </TableHead>
            <TableBody>
              {merchants.map((merchant, merchantIndex) => (
                <ReportTableRow key={merchantIndex}>
                  <TableCell>{merchant.merchantName}</TableCell>
                  <TableCell>{merchant.merchantID}</TableCell>
                  <TableCell align="right">
                    {merchant.summary?.terminal_count || 0}
                  </TableCell>
                  <TableCell align="right">
                    {merchant.summary?.total_transaction_count || 0}
                  </TableCell>
                  <AmountCell align="right">
                    ${formatNumber(merchant.summary?.total_transaction_amount)}
                  </AmountCell>
                  <TableCell align="right">
                    ${merchant.summary?.total_percent_tx_processing || 0}
                  </TableCell>
                  <TableCell align="right">
                    ${formatNumber(merchant.summary?.total_monthly_amount_peer_mid)}
                  </TableCell>
                  <TableCell align="right">
                    ${formatNumber(merchant.summary?.total_fiat_tx_processing)}
                  </TableCell>
                  <AmountCell
                    align="right"
                    positive={isPositiveAmount(merchant.summary?.total_fees)}
                    >
                    ${formatNumber(merchant.summary?.total_fees)}
                  </AmountCell>
                  
                </ReportTableRow>
              ))}
            </TableBody>
          </ReportTable>
        </TableContainer>
      </DataCard>
    </GridItem>
  );
};

export default MonthlyReportMerchantsTable;

